import { render } from "./productPopup.vue?vue&type=template&id=a0f23938&scoped=true"
import script from "./productPopup.vue?vue&type=script&lang=js"
export * from "./productPopup.vue?vue&type=script&lang=js"

import "./productPopup.vue?vue&type=style&index=0&id=a0f23938&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\Normann\\Configurator Dashboard\\normann-dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0f23938"]])

export default __exports__